import { com } from '@eidu/web'
import type { SnapshotEntity, GetEntitiesById } from 'runtimes-shared'
import queryClient from '../../queryClient'
import { fetchEntitiesByIds } from '../../useEntities'
import { entityKeys, entityTypeKeys } from '../../queryKeys'
import { fetchAllEntityTypes } from '../../useEntityTypes'
import Entity = com.eidu.sharedlib.entity.Entity
import entityIdFromString = com.eidu.sharedlib.entity.entityIdFromString

const getEntitiesById: GetEntitiesById = async (entityIds) => {
  if (entityIds.length === 0) return []

  const ids = entityIds.map(entityIdFromString)
  const types = await queryClient.fetchQuery({ queryKey: entityTypeKeys.list(), queryFn: fetchAllEntityTypes })
  const fetched = await fetchEntitiesByIds(ids, types)
  fetched.forEach((entity, id) => queryClient.setQueryData(entityKeys.detail(id), entity ?? null))

  const results: SnapshotEntity[] = []
  for (const entityId of entityIds) {
    const entityWithLabel = fetched.get(entityIdFromString(entityId))
    if (!entityWithLabel) continue

    const typeId = entityWithLabel.entity.typeId.toString()
    const kind = types.get(entityWithLabel.entity.typeId)?.kind?.toString() ?? 'Generic'
    // The serializer is the only way to get values in their JSON form; it omits empty maps.
    const json = JSON.parse(Entity.toJsonString(entityWithLabel.entity)) as Partial<
      Pick<SnapshotEntity, 'valuesByFieldId' | 'links'>
    >
    results.push({
      entityId,
      typeId,
      kind,
      // Fall back to the id like the field app does, so dropdowns never show blank options.
      primaryLabel: entityWithLabel.primaryLabelText || entityId,
      secondaryLabel: entityWithLabel.secondaryLabelText,
      valuesByFieldId: json.valuesByFieldId ?? {},
      links: json.links ?? {},
    })
  }

  return results
}

export default getEntitiesById
